import React from "react"
import ReactDOM from "react-dom"
import HeroBannerVideoComponent from "./hero-banner-video-component"

export default class HeroBannerVideoModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<HeroBannerVideoComponent {...this.modelJson} />, self.elem)
  }
}
